<template>
  <div className="lottie-bg">
    <div id="lottie">
      <img
          src="@assets/images/live-logo.gif"
          rel="preload"
          style="width: 100%;"
      />
    </div>
  </div>
</template>

<script>
import {auth} from "@libs/wechat";
import cookie from "@utils/store/cookie";
import router from "@/router";

export default {
  name: "Loading",
  mounted() {
    const {code, state} = this.$route.query;

    var search = 'authorizestate';
    var start = state.indexOf(search);//获得字符串的开始位置
    var uid = state.substring(start + search.length, state.length);//截取字符串

    var tz_back_url = cookie.get('login_back_url');

    const {fullPath, name} = router.currentRoute;


    auth(code)
        .then(res => {

          console.log(res);


          if (res.status == 4001) {
            location.href = "/register/" + res.cacheKey;
          } else {
            location.href = "/user";
            /*if(tz_back_url){
              location.replace(tz_back_url);
            }else {
              location.href = decodeURIComponent(
                  decodeURIComponent(this.$route.params.url)
              );
            }*/
          }


        })
        .catch(() => {
          location.href = "/user";
          /*if(tz_back_url){
              location.replace(tz_back_url);
          }else{
              //location.replace('/');
              location.href = decodeURIComponent(
                  decodeURIComponent(this.$route.params.url)
              );
          }*/
        });
  }
};
</script>

<style scoped>
.lottie-bg {
  position: fixed;
  left: 0;
  top: 0;
  background-color: #fff;
  width: 100%;
  height: 100%;
  z-index: 999;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
}

#lottie {
  width: 35%;
  display: block;
  overflow: hidden;
  transform: translate3d(0, 0, 0);
  margin: auto;
}
</style>
